import { render, staticRenderFns } from "./secondindex.vue?vue&type=template&id=03243af8&scoped=true"
import script from "./secondindex.vue?vue&type=script&lang=js"
export * from "./secondindex.vue?vue&type=script&lang=js"
import style0 from "./secondindex.vue?vue&type=style&index=0&id=03243af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03243af8",
  null
  
)

export default component.exports